export const APP_NAME = "Torqo";
export const CITY_NAME = "Дніпро";
export const API_BASE_URL = "";
